export * from './lib/input-s';
